import { getCashSession } from '@/api/cash_management';
import { useQuery } from '@tanstack/react-query';

type UseGetCashSessionParams = {
  id?: string;
  enabled?: boolean;
};

export function useGetCashSession({
  id,
  enabled = true,
}: UseGetCashSessionParams) {
  return useQuery({
    queryKey: ['cash-session', id],
    queryFn: () => getCashSession(id || ''),
    enabled: !!id && enabled,
    staleTime: 1000 * 60 * 1,
  });
}
